import { render, staticRenderFns } from "./ChannelsTileView.vue?vue&type=template&id=1a675e6a&scoped=true&"
import script from "./ChannelsTileView.vue?vue&type=script&lang=ts&"
export * from "./ChannelsTileView.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelsTileView.vue?vue&type=style&index=0&id=1a675e6a&scoped=true&lang=scss&"
import style1 from "./ChannelsTileView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a675e6a",
  null
  
)

export default component.exports